export const NavigationItems = {
  LOD: {
    id: "lod",
    name: "LOD",
  },
  LOD_ASSIGNMENT: {
    id: "lod-assignment",
    name: "LOD Assignment",
  },
  LAD: {
    id: "lad",
    name: "LAD",
  },
  GCG: {
    id: "gcg",
    name: "GCG",
  },
  SSCC: {
    id: "sscc",
    name: "SSCC",
  },
} as const;

export type NavigationItemId =
  (typeof NavigationItems)[keyof typeof NavigationItems]["id"];

export type NavigationItem = {
  id: NavigationItemId;
  name: string;
};
